import { Component, Input } from '@angular/core';
import { MatTabNavPanel } from '@angular/material/tabs';
import { DictionaryType, dictionaries } from './dictionaries';

@Component({
  standalone: false,
  selector: 'dictionaries-layout',
  templateUrl: './dictionaries.component.html',
  styleUrls: ['./dictionaries.component.css']
})
export class DictionaryLayout {
  @Input() title: string = 'DICTIONARY';
  @Input() type?: DictionaryType;

  tabPanel = new MatTabNavPanel();
  links = dictionaries;
}